import React from "react";
import styles from "./Chat.module.css";
import Contacts from "./Contacts";
import { BsChevronDown } from "react-icons/bs";
import { MdClose } from "react-icons/md";
import Thread from "./Thread";

const ChatWindow = ({
  contacts,
  newChat,
  contact,
  removeChat,
  thread,
  user,
}) => {
  const [open, setOpen] = React.useState(true);

  return (
    <div className={open ? styles.open : styles.closed}>
      <div className={styles.window}>
        <div className={styles.header} onClick={() => setOpen(!open)}>
          {contacts ? "Chats" : contact.name}

          <div className={styles.controls}>
            {contact ? (
              <MdClose
                className={styles.chevron}
                onClick={() => removeChat(contact)}
              />
            ) : (
              <MdClose className={styles.chevron} onClick={removeChat} />
            )}
            <BsChevronDown className={styles.chevron} />
          </div>
        </div>
        <div className={`${styles.body} ${!contacts ? styles.chatBody : ""}`}>
          <div className={styles.feed}>
            {contacts ? (
              <Contacts contacts={contacts} newChat={newChat} removeChat={removeChat} />
            ) : (
              <Thread contact={contact} thread={thread} user={user} />
            )}
          </div>
          <div className={styles.input}></div>
        </div>
      </div>
    </div>
  );
};

export default ChatWindow;
